import React, { PureComponent } from 'react';
import Text from '../../../components/Text.js';
import BubbleSelectBlock from '../../../components/BubbleSelectBlock.js';
import * as Theme from '../../../theme/index.js';
import { Info as InfoIcon } from "@mui/icons-material";
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
class Enrolment extends PureComponent {
  _saveEnrolmentAnswer = (questionID, answer) => {
    const memberData = this.props.purchaseData.memberData;
    const enrolmentQuestions = this.props.purchaseData.enrolmentQuestions;
    if (!enrolmentQuestions[questionID]) {
      enrolmentQuestions[questionID] = {
        questionID,
        answer
      };
    } else {
      enrolmentQuestions[questionID].answer = answer;
    }
    if (this.props.product.enrolmentQuestions[questionID].memberRecordField && this.props.product.enrolmentQuestions[questionID].memberRecordField.length > 0) {
      memberData[this.props.product.enrolmentQuestions[questionID].memberRecordField] = answer;
    }
    this.props.savePurchaseData({
      ...this.props.purchaseData,
      memberData: {
        ...memberData
      },
      enrolmentQuestions
    });
  };
  render() {
    const styles = {
      bulletBlock: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
        marginBottom: 20,
        alignItems: 'flex-start'
      },
      questionBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 20
      }
    };
    const product = this.props.product;
    const purchaseData = this.props.purchaseData;
    const enrolmentErrors = this.props.enrolmentErrors;
    const productName = `${product.type.toUpperCase() === 'VOLUNTARY' ? i18n.t(tokens.labels.marketplace.voluntary) : i18n.t(tokens.labels.marketplace.optional)} ${product.name.primary[this.props.member.language]}`;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: 20
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      display: "inline"
    }, i18n.t(tokens.labels.marketplace.youHaveSelected), " "), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      display: "inline"
    }, productName), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      display: "inline"
    }, ` ${i18n.t(tokens.labels.marketplace.with)}`, " "), /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      display: "inline"
    }, product.carrier[this.props.member.language], ". "), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      display: "inline"
    }, i18n.t(tokens.labels.marketplace.beforeYouGetStarted))), /*#__PURE__*/React.createElement("div", {
      style: styles.bulletBlock
    }, /*#__PURE__*/React.createElement(InfoIcon, {
      "aria-label": "info",
      style: {
        fontSize: 15,
        color: Theme.colors.mediumGrey,
        marginRight: 10
      }
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, product.type.toUpperCase() === 'VOLUNTARY' ? i18n.t(tokens.labels.marketplace.productSeparateInfoVoluntary) : i18n.t(tokens.labels.marketplace.productSeparateInfoOptional))), /*#__PURE__*/React.createElement("div", {
      style: styles.bulletBlock
    }, /*#__PURE__*/React.createElement(InfoIcon, {
      "aria-label": "info",
      style: {
        fontSize: 15,
        color: Theme.colors.mediumGrey,
        marginRight: 10
      }
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.marketplace.coverageEffectiveDate, {
      product: productName
    }))), /*#__PURE__*/React.createElement("div", {
      style: styles.bulletBlock
    }, /*#__PURE__*/React.createElement(InfoIcon, {
      "aria-label": "info",
      style: {
        fontSize: 15,
        color: Theme.colors.mediumGrey,
        marginRight: 10
      }
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, product.type.toUpperCase() === 'VOLUNTARY' ? i18n.t(tokens.labels.marketplace.invoiceInfoVoluntary) : i18n.t(tokens.labels.marketplace.invoiceInfoOptional))), /*#__PURE__*/React.createElement("div", {
      style: styles.bulletBlock
    }, /*#__PURE__*/React.createElement(InfoIcon, {
      "aria-label": "info",
      style: {
        fontSize: 15,
        color: Theme.colors.mediumGrey,
        marginRight: 10
      }
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, product.type.toUpperCase() === 'VOLUNTARY' ? product.coveragePeriodType.toUpperCase() === 'YEAR' ? i18n.t(tokens.labels.marketplace.productChangeYearlyTermInfoVoluntary, {
      product: productName
    }) : i18n.t(tokens.labels.marketplace.productChangeMonthlyTermInfoVoluntary, {
      product: productName
    }) : i18n.t(tokens.labels.marketplace.productChangeInfoOptional, {
      product: productName
    }))), Object.keys(product.enrolmentQuestions).length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(product.enrolmentQuestions).length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      small: true,
      light: true,
      margin: "20px 0 0 0"
    }, i18n.t(tokens.labels.marketplace.disclosureInfo, {
      product: productName
    })), Object.keys(product.enrolmentQuestions).map(questionID => {
      const question = product.enrolmentQuestions[questionID];
      return /*#__PURE__*/React.createElement("div", {
        style: styles.questionBlock,
        key: questionID
      }, enrolmentErrors[questionID] && /*#__PURE__*/React.createElement(Text, {
        small: true,
        bold: true,
        color: "red",
        margin: "10px 0 0 0"
      }, i18n.t(tokens.labels.marketplace.selectOptionInfo)), /*#__PURE__*/React.createElement(Text, {
        small: true,
        bold: true,
        margin: "0 10px 0 0"
      }, question.verbiage[this.props.member.language]), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
        allowToggleOff: false,
        first: {
          title: i18n.t(tokens.buttons.yes),
          selected: purchaseData.enrolmentQuestions[questionID].answer === true,
          field: 'yes',
          customStyle: {
            fontSize: 12
          }
        },
        second: {
          title: 'No',
          selected: purchaseData.enrolmentQuestions[questionID].answer === false,
          field: 'no',
          customStyle: {
            fontSize: 12
          }
        },
        handleChange: field => {
          this._saveEnrolmentAnswer(question.questionID, field === 'yes');
        }
      }));
    }))));
  }
}
export default Enrolment;